<template>
  <div id="add-custom-grid">
    <b-modal
      id="confirmDeleteConfirmModal"
      size="md"
      class="popover-modal"
      hide-header
      hide-footer
      no-close-on-esc
      :scrollable="true"
      @hide="hideModal"
      ref="confirmDeleteConfirmModal"
    >
      <VpConfirmModal v-if="showModal" :modalId="'confirmDeleteConfirmModal'">
        <template v-slot:title>
          <span
            >{{ $t("common.delete") }}
            {{ $t("journeyBuilder.flow.section") }}</span
          >
        </template>

        <template v-slot:text1>
          <span
            >{{ $t("common.notes.areYouSureYouWant") }}
            <strong>“{{ $t("common.delete") }}”</strong>
            {{ $t("common.notes.this") }}
            {{ $t("customFields.form.thisSection")
            }}{{ $t("common.questionMark") }}</span
          >
        </template>

        <template v-slot:text2>
          <span>
            {{ $t("common.notes.byDeletingThis") }}
            {{ $t("customFields.form.thisSection") }}{{ $t("common.comma") }}
            {{
              data?.bindedto === $t("complianceList.form.userProfile")
                ? $t("customFields.notes.willBeRemovedProfile")
                : $t("customFields.notes.willBeRemovedFlow")
            }}
            {{ $t("customFields.notes.allUsers") }}
          </span>
        </template>

        <template v-slot:buttons>
          <VpButton
            :text="$t('common.cancel')"
            @click="$bvModal.hide('confirmDeleteConfirmModal')"
          />
          <VpButton
            :text="$t('common.delete')"
            :disabled="isLoading"
            :isLoading="isLoading"
            :isDanger="true"
            @click="onDeleteSection"
          />
        </template>
      </VpConfirmModal>
    </b-modal>

    <b-modal
      id="exportingProgress"
      hide-footer
      hide-header
      size="lg"
      :scrollable="false"
    >
      <ExportProgress />
    </b-modal>

    <PageHeader
      className="d-flex align-items-center"
      :title="$t('sideNavbarMenu.settings.list.customFields')"
    >
      <div class="page-title-right" style="z-index: 9">
        <div class="dropdown added-comp">
          <div class="add-tool-con d-flex align-items-center">
            <button
              @click="showMenu = !showMenu"
              class="d-flex align-items-center justify-content-center text-center add-compliance-category cursor-pointer"
              :disabled="entityIsLitePlan"
            >
              {{ $t("common.add") }}
            </button>

            <svg
              v-show="entityIsLitePlan"
              style="margin-inline-start: 8px"
              width="12"
              height="16"
              v-b-tooltip
              id="options-lock"
              viewBox="0 0 17 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.2691 7.29675V5.68077C14.2363 4.16287 13.614 2.71827 12.5357 1.65644C11.4574 0.594606 10.0087 0 8.5 0C6.99132 0 5.54264 0.594606 4.46431 1.65644C3.38597 2.71827 2.76374 4.16287 2.73092 5.68077V7.29675C2.00664 7.29675 1.31202 7.5863 0.799869 8.1017C0.287721 8.6171 0 9.31614 0 10.045V19.2517C0 19.9806 0.287721 20.6796 0.799869 21.195C1.31202 21.7104 2.00664 22 2.73092 22H14.2691C14.9934 22 15.688 21.7104 16.2001 21.195C16.7123 20.6796 17 19.9806 17 19.2517V10.045C17 9.31614 16.7123 8.6171 16.2001 8.1017C15.688 7.5863 14.9934 7.29675 14.2691 7.29675ZM9.591 16.1929C9.591 16.4845 9.47591 16.7641 9.27106 16.9702C9.0662 17.1764 8.78835 17.2922 8.49863 17.2922C8.20892 17.2922 7.93107 17.1764 7.72621 16.9702C7.52135 16.7641 7.40626 16.4845 7.40626 16.1929V13.1011C7.40626 12.8095 7.52135 12.5299 7.72621 12.3238C7.93107 12.1176 8.20892 12.0018 8.49863 12.0018C8.78835 12.0018 9.0662 12.1176 9.27106 12.3238C9.47591 12.5299 9.591 12.8095 9.591 13.1011V16.1929ZM12.0843 7.29675H4.91566V5.68077C4.94143 4.74134 5.33037 3.8491 5.99975 3.1938C6.66914 2.53851 7.56615 2.17187 8.5 2.17187C9.43385 2.17187 10.3309 2.53851 11.0002 3.1938C11.6696 3.8491 12.0586 4.74134 12.0843 5.68077V7.29675Z"
                fill="#103F5E"
              />
            </svg>
            <b-tooltip
              id="category"
              class="lock-msg"
              target="options-lock"
              triggers="click blur"
              placement="rightbottom"
            >
              <ul style="margin-bottom: 0px">
                <li
                  class="feature-availability"
                  style="margin-bottom: 8px; text-align: start"
                >
                  {{ $t("customFields.form.lockedFeature") }}
                </li>

                <li class="feature-upgrade" style="text-align: start">
                  {{ $t("customFields.form.lockedFeatureInfo") }}
                  <span
                    class="mail"
                    style="
                      color: #2680eb;
                      font-weight: 700;
                      text-decoration: underline;
                    "
                    >cs@lamasatech.com.</span
                  >
                </li>
              </ul>
            </b-tooltip>
          </div>
          <div
            v-if="showMenu"
            id="compDropdown"
            class="dropdown-content compliance"
          >
            <ul>
              <li
                class="category-list d-flex clickable-add"
                style="
                  text-align: center;
                  padding-top: 0px;
                  position: relative;
                  padding-bottom: 0px;
                "
              >
                <button
                  v-if="allSections.length > 1"
                  @focus="showSubMenu = true"
                  class="category-text cursor-pointer"
                >
                  {{ $t("customFields.form.addToExistingSection") }}
                </button>

                <template v-else>
                  <router-link
                    :to="`/add-custom-field?sectionId=${
                      allSections.find((section) => section.isMainSection)?.id
                    }&scroll=${true}`"
                  >
                    <button class="category-text">
                      {{ $t("customFields.form.addTo") }}
                      {{
                        allSections.find((section) => section.isMainSection)
                          ?.name
                      }}
                    </button>
                  </router-link>
                </template>

                <div
                  v-if="showSubMenu"
                  id="compDropdown"
                  class="dropdown-content-two compliance"
                >
                  <ul
                    style="
                      width: 127px;
                      padding-top: 16px;
                      padding-bottom: 16px;
                    "
                  >
                    <router-link
                      :to="`/add-custom-field?sectionId=${
                        allSections.find((section) => section.isMainSection).id
                      }&scroll=${true}`"
                    >
                      <li class="compliance-list-two">
                        <p class="sub-menu-text cursor-pointer">{{
                          allSections.find((section) => section.isMainSection)
                            .name
                        }}</p>
                      </li>
                    </router-link>
                    <li class="line-sep"></li>

                    <template
                      v-for="(section, i) in allSections.filter(
                        (section) => !section.isMainSection
                      )"
                    >
                      <div v-if="i !== allSections.length - 1" :key="i">
                        <router-link
                          :to="`/add-custom-field?sectionId=${
                            section.id
                          }&scroll=${true}`"
                        >
                          <li class="compliance-list-two">
                            <p class="sub-menu-text cursor-pointer">{{
                              section.name
                            }}</p>
                          </li>
                        </router-link>
                        <li
                          v-if="i !== allSections.length - 2"
                          class="line-sep"
                        ></li>
                      </div>
                    </template>
                  </ul>
                </div>
              </li>
              <li class="line-sep" style="margin-top: 0px"></li>
              <router-link to="/add-custom-field">
                <li class="compliance-list cusror-pointer">
                  <button class="category-text cursor-pointer" style="padding: 0 10px !important">{{
                    $t("customFields.form.addNewSection")
                  }}</button>
                </li>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
    </PageHeader>

    <!-- grid -->
    <section class="custom-white-bg-sec custom-field-grid">
      <DxTreeList
        id="customFieldsTreelist"
        :data-source="dataSource"
        :rtl-enabled="rtlEnabled"
        :ref="CustomFieldsRefName"
        :no-data-text="$t('common.grid.noRecordsYet')"
        :column-auto-width="true"
        :row-alternation-enabled="false"
        :show-column-lines="true"
        :show-row-lines="true"
        :show-border="false"
        :word-wrap-enabled="true"
        :allowColumnResizing="true"
        :rowAlternationEnabled="false"
        :repaint-changes-only="true"
        :two-way-binding-enabled="true"
        :allow-column-reordering="true"
        key-expr="id"
        parent-id-expr="parentId"
        @content-ready="contentReady($event)"
        @editor-preparing="onEditorPreparing"
        @data-error-occurred="onDataErrorOccurred($event)"
      >
        <DxStateStoring
          :enabled="true"
          type="custom"
          :customSave="customSave"
          :customLoad="customLoad"
        />
        <DxHeaderFilter :visible="true" />
        <!-- <DxSelection mode="multiple" /> -->
        <DxColumnChooser
          :enabled="true"
          mode="select"
          :title="$t('common.grid.columnChooser')"
        />
        <DxFilterRow :visible="true" />
        <DxLoadPanel :enabled="true"> </DxLoadPanel>
        <!-- start::Toolbar -->
        <DxToolbar>
          <DxItem location="before" template="columnButtonTemplate" />
          <DxItem template="exportButtonTemplate" location="before" />
          <DxItem template="clearAllTemplate" location="before" />
        </DxToolbar>
        <!-- end::Toolbar -->

        <!-- start::Pager -->
        <!-- <DxPaging :enabled="true" :page-size="10" /> -->
        <DxPager
          :visible="false"
          displayMode="full"
          :show-page-size-selector="false"
          :allowed-page-sizes="['all']"
          :show-info="true"
          :show-navigation-buttons="true"
          :infoText="rtlEnabled ?  'صفحة {0} من {1} ({2} إجمالي العناصر)' : ''"
        />
        <!-- end::Pager -->

        <!-- start::scrolling -->
        <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />
        <!-- end::scrolling -->

        <!-- start::Column Button Template -->
        <template #columnButtonTemplate>
          <button class="custom-columns" @click="treelist.showColumnChooser()">
            <span class="custom-text">{{ $t("common.grid.columns") }} </span>

            <span class="custom-icon">
              <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
            </span>
          </button>
        </template>
        <!-- end::Column Button Template -->

        <!-- start::Export Button -->
        <template #exportButtonTemplate class="export-dropdown">
          <DxDropDownButton
            class="export-dropdown"
            :items="buttonData"
            @item-click="serverSideExport"
            :text="$t('common.grid.export')"
          />
        </template>
        <!-- end::Export Button -->

        <!-- start::Clear All Button Template -->
        <template #clearAllTemplate>
          <div v-if="showClearAll" class="clear-cols d-flex align-items-center">
            <div class="toolbar-custom-line"></div>
            <Button
              :text="$t('common.grid.clearFilters')"
              @click="clearFilter"
              styling-mode="outlined"
              type="danger"
              class="clear-CustomColums"
            />
          </div>
        </template>
        <!-- end::Clear All Button Template -->

        <DxColumn
          data-field="name"
          :caption="$t('common.name')"
          :allow-header-filtering="false"
          :min-width="285"
          :allow-filtering="true"
          :allow-reordering="false"
          :filter-operations="allowedOperations"
        />
        <DxColumn
          data-field="bindedto"
          :caption="$t('customFields.grid.bindedTo')"
          :min-width="150"
          :allow-header-filtering="true"
          :allow-filtring="true"
          :filter-operations="allowedOperations"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <DxColumn
          data-field="usertype"
          :caption="$t('common.userType')"
          :min-width="208"
          :allow-header-filtering="false"
          :allow-filtering="true"
          :filter-operations="allowedOperations"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <DxColumn
          data-field="fieldtype"
          :caption="$t('customFields.grid.fieldType')"
          :min-width="150"
          :allow-header-filtering="true"
          :allow-filtering="true"
          :filter-operations="allowedOperations"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <DxColumn
          data-field="mandatory"
          :caption="$t('common.mandatory')"
          :min-width="142"
          :allow-header-filtering="true"
          :allow-filtering="true"
          :filter-operations="allowedOperations"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <DxColumn
          data-field="fillablebyuser"
          :caption="$t('customFields.grid.fillableByUser')"
          :min-width="180"
          :allow-header-filtering="true"
          :allow-filtering="true"
          :filter-operations="allowedOperations"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <DxColumn
          data-field="printableonbadge"
          :caption="$t('customFields.grid.printableOnBadge')"
          :min-width="200"
          :allow-header-filtering="true"
          :allow-filtering="true"
          :filter-operations="allowedOperations"
          :show-in-column-chooser="true"
          :allow-exporting="true"
        >
          <DxHeaderFilter :dataSource="customizeHeaderFilter" />
        </DxColumn>
        <DxColumn
          data-field="showon"
          :caption="$t('customFields.grid.showOn')"
          :min-width="150"
          :allow-header-filtering="true"
          :allow-filtering="true"
          :filter-operations="allowedOperations"
        >
          <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
        </DxColumn>
        <DxColumn
          data-field="actions"
          :caption="$t('common.grid.actions')"
          :allow-filtering="false"
          :allow-exporting="false"
          :allow-editing="false"
          :allow-sorting="false"
          cell-template="action-cell"
          :min-width="100"
        >
        </DxColumn>
        <template #action-cell="{ data }">
          <div v-if="!data.data.parentId" class="d-flex">
            <div class="edit-lock d-flex">
              <router-link :to="`/add-custom-field?sectionId=${data.data.id}`">
                <button :disabled="entityIsLitePlan" class="unique-edit-button cursor-pointer" style="width: 16px; height: 16px;">
                  <svg
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="width: 16px; height: 16px;"
                  >
                    <path
                      d="M15.4058 9.49869C14.7489 9.49869 14.2115 10.0361 14.2115 10.6929V13.0217C14.2115 14.007 13.4054 14.8131 12.4201 14.8131H4.17986C3.1946 14.8131 2.38849 14.007 2.38849 13.0217V4.78142C2.38849 3.79617 3.1946 2.99005 4.17986 2.99005H6.50863C7.16547 2.99005 7.70288 2.45264 7.70288 1.79581C7.70288 1.13897 7.16547 0.601562 6.50863 0.601562H4.17986C1.88094 0.601562 0 2.4825 0 4.78142V13.0217C0 15.3206 1.88094 17.2016 4.17986 17.2016H12.4201C14.7191 17.2016 16.6 15.3206 16.6 13.0217V10.6929C16.6 10.0361 16.0626 9.49869 15.4058 9.49869Z"
                      :fill="entityIsLitePlan ? '#9FB2BF' : '#103F5E'"
                    />
                    <path
                      d="M5.40536 8.15292L4.56939 11.1385C4.39026 11.7655 4.74853 12.4223 5.40536 12.6015C5.61436 12.6612 5.85321 12.6612 6.0622 12.6015L9.04781 11.7655C9.2568 11.7058 9.43594 11.6162 9.58522 11.467L15.7057 5.3763C16.7805 4.30148 16.7805 2.59969 15.7057 1.52487C14.6309 0.450045 12.9291 0.450045 11.8543 1.52487L5.70393 7.64537C5.55465 7.79465 5.46508 7.97379 5.40536 8.15292ZM13.4964 3.22666C13.6158 3.10724 13.8546 3.10724 13.9741 3.22666C14.0935 3.34609 14.0935 3.58494 13.9741 3.70436L8.74925 8.92918L8.27155 8.45148L13.4964 3.22666Z"
                      :fill="entityIsLitePlan ? '#9FB2BF' : '#103F5E'"
                    />
                  </svg>
                </button>
              </router-link>
              <div class="add-tool-con-two d-flex align-items-center">
                <svg
                  v-show="entityIsLitePlan"
                  style="margin-inline-start: 8px"
                  width="12"
                  height="16"
                  v-b-tooltip
                  :id="'category-two' + data.data.id"
                  viewBox="0 0 17 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.2691 7.29675V5.68077C14.2363 4.16287 13.614 2.71827 12.5357 1.65644C11.4574 0.594606 10.0087 0 8.5 0C6.99132 0 5.54264 0.594606 4.46431 1.65644C3.38597 2.71827 2.76374 4.16287 2.73092 5.68077V7.29675C2.00664 7.29675 1.31202 7.5863 0.799869 8.1017C0.287721 8.6171 0 9.31614 0 10.045V19.2517C0 19.9806 0.287721 20.6796 0.799869 21.195C1.31202 21.7104 2.00664 22 2.73092 22H14.2691C14.9934 22 15.688 21.7104 16.2001 21.195C16.7123 20.6796 17 19.9806 17 19.2517V10.045C17 9.31614 16.7123 8.6171 16.2001 8.1017C15.688 7.5863 14.9934 7.29675 14.2691 7.29675ZM9.591 16.1929C9.591 16.4845 9.47591 16.7641 9.27106 16.9702C9.0662 17.1764 8.78835 17.2922 8.49863 17.2922C8.20892 17.2922 7.93107 17.1764 7.72621 16.9702C7.52135 16.7641 7.40626 16.4845 7.40626 16.1929V13.1011C7.40626 12.8095 7.52135 12.5299 7.72621 12.3238C7.93107 12.1176 8.20892 12.0018 8.49863 12.0018C8.78835 12.0018 9.0662 12.1176 9.27106 12.3238C9.47591 12.5299 9.591 12.8095 9.591 13.1011V16.1929ZM12.0843 7.29675H4.91566V5.68077C4.94143 4.74134 5.33037 3.8491 5.99975 3.1938C6.66914 2.53851 7.56615 2.17187 8.5 2.17187C9.43385 2.17187 10.3309 2.53851 11.0002 3.1938C11.6696 3.8491 12.0586 4.74134 12.0843 5.68077V7.29675Z"
                    fill="#103F5E"
                  />
                </svg>
                <b-tooltip
                  id="category-two"
                  class="lock-msg"
                  :target="'category-two' + data.data.id"
                  triggers="click blur"
                  placement="rightbottom"
                >
                  <ul style="margin-bottom: 0px">
                    <li
                      class="feature-availability"
                      style="margin-bottom: 8px; text-align: start"
                    >
                      {{ $t("customFields.form.lockedFeature") }}
                    </li>

                    <li class="feature-upgrade" style="text-align: start">
                      {{ $t("customFields.form.lockedFeatureInfo") }}
                      <span
                        class="mail"
                        style="
                          color: #2680eb;
                          font-weight: 700;
                          text-decoration: underline;
                        "
                        >cs@lamasatech.com.</span
                      >
                    </li>
                  </ul>
                </b-tooltip>
              </div>
            </div>
            <button
              v-if="!entityIsLitePlan && !data.data.isMainSection"
              @click="deleteItem(data.data)"
              class="delete-button cursor-pointer"
              style="width: 16px; height: 16px;"
            >
              <svg
                width="13"
                height="17"
                viewBox="0 0 13 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="width: 16px; height: 16px;"
              >
                <path
                  d="M12.1412 1.82143H9.10547V1.21429C9.10547 0.546429 8.55904 0 7.89118 0H5.46261C4.79475 0 4.24833 0.546429 4.24833 1.21429V1.82143H1.21261C0.848326 1.82143 0.605469 2.06429 0.605469 2.42857C0.605469 2.79286 0.848326 3.03571 1.21261 3.03571H4.85547H8.49833H12.1412C12.5055 3.03571 12.7483 2.79286 12.7483 2.42857C12.7483 2.06429 12.5055 1.82143 12.1412 1.82143ZM5.46261 1.82143V1.21429H7.89118V1.82143H5.46261Z"
                  fill="#F46A6A"
                />
                <path
                  d="M12.5662 3.82277C12.5055 3.70134 12.3233 3.64062 12.1412 3.64062H1.21261C1.03047 3.64062 0.848326 3.70134 0.787612 3.82277C0.666183 3.9442 0.605469 4.12634 0.605469 4.30848L1.69833 15.3585C1.81975 16.2692 2.60904 16.9978 3.51975 16.9978H9.83404C10.7448 16.9978 11.534 16.3299 11.6555 15.3585L12.7483 4.30848C12.7483 4.12634 12.6876 3.9442 12.5662 3.82277ZM4.30904 14.5692C3.94475 14.5692 3.7019 14.3263 3.64118 14.0228L3.03404 6.73705C3.03404 6.37277 3.2769 6.12991 3.58047 6.0692C3.94475 6.00848 4.18761 6.31205 4.24833 6.61562L4.85547 13.9013C4.85547 14.2656 4.61261 14.5692 4.30904 14.5692ZM7.28404 13.9621C7.28404 14.3263 7.04118 14.5692 6.6769 14.5692C6.31261 14.5692 6.06975 14.3263 6.06975 13.9621V6.67634C6.06975 6.31205 6.31261 6.0692 6.6769 6.0692C7.04118 6.0692 7.28404 6.31205 7.28404 6.67634V13.9621ZM9.71261 14.0228C9.71261 14.3263 9.40904 14.5692 9.10547 14.5692H9.04475C8.68047 14.5692 8.43761 14.2656 8.49833 13.9013L9.10547 6.61562C9.10547 6.25134 9.40904 6.00848 9.77332 6.0692C10.1376 6.0692 10.3805 6.37277 10.3198 6.73705L9.71261 14.0228Z"
                  fill="#F46A6A"
                />
              </svg>
            </button>
          </div>
        </template>
      </DxTreeList>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { default as Button } from "devextreme-vue/button";

import PageHeader from "@/components/page-header";
import ExportProgress from "@/components/grid/ExportProgress";

import {
  DxTreeList,
  DxColumn,
  DxColumnChooser,
  DxHeaderFilter,
  DxToolbar,
  DxItem,
  DxFilterRow,
  // DxPaging,
  DxPager,
  DxScrolling,
  DxLoadPanel,
  //   DxSelection,
  //   DxLookup,
  DxStateStoring,
} from "devextreme-vue/tree-list";

export default {
  title: "Custom fields",
  components: {
    DxTreeList,
    PageHeader,
    ExportProgress,
    DxDropDownButton,
    DxColumn,
    DxItem,
    Button,
    DxFilterRow,
    DxHeaderFilter,
    DxStateStoring,
    DxPager,
    DxToolbar,
    DxColumnChooser,
    DxLoadPanel,
    DxScrolling,
  },
  data() {
    return {
      rtlEnabled: false,
      showModal: true,
      showMenu: false,
      showSubMenu: false,
      showClearAll: false,
      allowedOperations: ["contains"],
      columnsFilters: [],
      buttonData: ["PDF", "Excel", "CSV"],
      CustomFieldsRefName: "customFieldsTreelist",
      data: null,
      isLoading: false,
      dataSource: [],
      allSections: [],
      // Dummy data for testing
      showOnOptions: {
        check_in: this.$t("common.checkIn"),
        sign_in: this.$t("common.signIn"),
        sign_out: this.$t("common.signOut"),
      },
      fieldTypeMapper:{
        date:this.$t("customFields.form.date"),
        number:this.$t("customFields.form.number"),
        text:this.$t("customFields.form.text"),
        checkboxes:this.$t("customFields.form.checkboxes"),
        radioButtons	:this.$t("customFields.form.radioButtons"),
        ratingScale: this.$t("customFields.form.ratingScale"),
        toggleButton:this.$t("customFields.form.toggleButton"),
        longText:this.$t("customFields.form.longText"),
      }
    };
  },
  beforeMount() {
    this.fetchData();
    if (this.getLanguage == "ar") {
      this.rtlEnabled = true;
    }
  },
  created() {
    document.addEventListener("mousedown", (e) => {
      const compDropdown = document.getElementById("compDropdown");
      const addBtn = document.querySelector(".add-compliance-category");

      if (
        compDropdown &&
        addBtn &&
        !compDropdown.contains(e.target) &&
        !addBtn.contains(e.target)
      ) {
        // Clicked outside the dropdown menu and the add button, so hide the menu
        this.showMenu = false;
        this.showSubMenu = false;
      }
    });
  },
  computed: {
    ...mapGetters("authfack", ["currentEntity", "getCurrentPlan"]),
    ...mapGetters("grid", ["getTableHeaders", "getExportProgessAppearance"]),
    ...mapGetters("i18N", ["getLanguage"]),
    treelist() {
      return this.$refs[this.CustomFieldsRefName].instance;
    },
    entityIsLitePlan() {
      return this.getCurrentPlan == 1;
    },
  },

  watch: {
    getExportProgessAppearance(value) {
      value && this.$bvModal.show("exportingProgress");
    },
  },

  methods: {
    ...mapActions("users", ["fetchAllSections", "deleteSection"]),
    ...mapActions("grid", [
      "createTableHeaders",
      "onTableHeader",
      "updateTableHeaders",
      "resetTableHeaders",
      "resetFilterValues",
      "onSetFilterValue",
      "exportJobBE",
    ]),
    fetchData() {
      this.dataSource = [];
      this.fetchAllSections().then((data) => {
        // console.log("fetchAllSections", data);
        this.allSections = data;
        data.forEach((obj) => {
          this.dataSource.push({
            ...obj,
            parentId: null,
            isMainSection: obj.isMainSection,
            bindedto:
              obj.user_types && obj.user_types.length
                ? this.$t("complianceList.form.userProfile")
                : this.$t('common.visit'),
            usertype:
              obj.user_types && obj.user_types.length
                ? obj.user_types.map((item) => item.name).join(" - ")
                : this.$t('customFields.grid.accordingToFlow'),
            fieldtype: "-",
            mandatory: "-",
            fillablebyuser: "-",
            printableonbadge: "-",
            showon: "-",
          });
          obj.custom_fields.forEach((field) => {
            // const words = field.type.split(/(?=[A-Z])/);
            // let normalizedText = words.join(" ").toLowerCase();
            // normalizedText =
            //   normalizedText.charAt(0).toUpperCase() + normalizedText.slice(1);

            const newField = {
              ...field,
              parentId: obj.id,
              bindedto: "-",
              usertype: "-",
              // fieldtype: normalizedText,
              fieldtype: this.fieldTypeMapper[field.type],
              mandatory: field.is_mandatory ? this.$t('common.yes') : this.$t('common.no'),
              fillablebyuser: field.is_fillable_by_user ? this.$t('common.yes') : this.$t('common.no'),
              printableonbadge: field.is_allowed_print ? this.$t('common.yes') : this.$t('common.no'),
              showon: this.showOnOptions[field.show_type],
            };
            this.dataSource.push(newField);
          });
        });
      });
    },
    customizeHeaderFilter(options) {
      options.dataSource.postProcess = function (items) {
        items = items.filter((item) => item.value && item.value !== "-");
        if (this.pageIndex() === 0) {
          items = items.slice(0);
          // items.unshift({ value: "-", text: "-" });
        }
        return items;
      };
    },
    onEditorPreparing(e) {
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = this.$t("common.grid.search");
      }
    },
    contentReady(e) {
      let sortedExp = this.getSortedColumns();
      // console.log("sortedExp", sortedExp);
      let filterExp = e.component.getCombinedFilter();
      if (filterExp || sortedExp) {
        this.showClearAll = true;
      } else {
        this.showClearAll = false;
      }
      this.setColumnChooserPosition();
    },
    getSortedColumns() {
      let allColumns = Array.from(
        Array(this.treelist.columnCount()).keys()
      ).map((index) => this.treelist.columnOption(index));
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    },
    setColumnChooserPosition() {
      var columnChooserView = this.treelist.getView("columnChooserView");

      if (!columnChooserView._popupContainer) {
        columnChooserView._initializePopupContainer();
        columnChooserView.render();
      }

      columnChooserView._popupContainer.option("position", {
        of: this.treelist.element(),
        my: this.getLanguage === "en" ? "left top" : "right top",
        at: this.getLanguage === "en" ? "left top" : "right top",
        offset: "0 50",
      });
    },
    async customLoad() {
      if (this.userEmail !== "lt_techteam@visipoint.com") {
        await this.onTableHeader({
          url: "/custom-fields",
        });
        let value = this.getTableHeaders;
        for (let i = 0; i < value.columns.length; i++) {
          if (
            value.columns[i].dataField == "actions"
          ) {
            value.columns[i].visibleIndex = value.columns.length - 1;
          }
        }
        return value;
      }
    },
    customSave(gridState) {
      if (this.userEmail !== "lt_techteam@visipoint.com") {
        gridState.pageIndex = 0;
        gridState.pageSize = 1000000;
        let value = JSON.stringify(gridState);
        value = value.replace(',"selectedRowKeys":[]', "");
        this.formatingFilterArr(value);
        if (!this.getTableHeaders) {
          this.createTableHeaders({
            url: "/custom-fields",
            headers: value,
            filters: "[]",
          });
        } else if (value != JSON.stringify(this.getTableHeaders)) {
          this.updateTableHeaders({
            url: "/custom-fields",
            headers: value,
            filters: "[]",
          });
        }
      }
    },
    formatingFilterArr(arr) {
      let columns = [];
      arr = JSON.parse(arr);
      console.log("arr.columns", arr.columns);
      arr.columns.map((obj) => {
        if (obj.name != 'actions') {
          delete obj.width;
          delete obj.dataField;
          delete obj.dataType;
          delete obj.filterType;
          if (obj.name == "name" && obj.filterValue) obj.filterVal = obj.filterValue;
          else if (obj.name == "bindedto" && obj.filterValues) {
            obj.filterVal = [];
            obj.filterValues.map((val) => {
              if (val == this.$t("complianceList.form.userProfile")) {
                obj.filterVal.push(0);
              } else if (val == this.$t('common.visit')) {
                obj.filterVal.push(1);
              } else obj.filterVal.push(val);
            })
          } else if (obj.name == "fieldtype" && obj.filterValues) {
            obj.filterVal = [];
            obj.filterValues.map((val) => {
              const entry = Object.entries(this.fieldTypeMapper).find(
                // eslint-disable-next-line no-unused-vars
                ([key, value]) => value === val
              );
              if (entry) {
                obj.filterVal.push(entry[0]);
              } else obj.filterVal.push(val);
            })
          } else if ((obj.name == "mandatory" || obj.name == "fillablebyuser") && obj.filterValues) {
            obj.filterVal = [];
            obj.filterValues.map((val) => {
              if (val == this.$t('common.yes')) {
                obj.filterVal.push(1);
              } else if (val == this.$t('common.no')) {
                obj.filterVal.push(0);
              } else obj.filterVal.push(val);
            })
          } else if (obj.name == "showon" && obj.filterValues) {
            obj.filterVal = [];
            obj.filterValues.map((val) => {
              const entry = Object.entries(this.showOnOptions).find(
                // eslint-disable-next-line no-unused-vars
                ([key, value]) => value === val
              );
              if (entry) {
                obj.filterVal.push(entry[0]);
              } else obj.filterVal.push(val);
            })
          }
          columns.push(obj);
        }
      });
      columns.sort((a, b) => {
        return a.visibleIndex - b.visibleIndex;
      });
      console.log("columns", columns);
      this.columnsFilters = columns;
    },
    clearFilter() {
      this.treelist.clearFilter("row");
      this.treelist.clearFilter("header");
      this.treelist.clearSorting();
      this.showClearAll = false;
    },
    serverSideExport(e) {
      this.exportJobBE({
        filterBy: this.columnsFilters,
        orderBy: "",
        type: e.itemData.toLowerCase(),
        gridName: "custom_fields",
      });
    },
    deleteItem(data) {
      this.data = data;
      this.showModal = true;
      this.$refs.confirmDeleteConfirmModal.show();
    },
    hideModal() {
      setTimeout(() => (this.showModal = false), 100);
    },
    onDeleteSection() {
      this.isLoading = true;
      console.log("section id", this.data.id);
      this.deleteSection(this.data.id)
        .then(() => {
          this.isLoading = false;
          this.fetchData();
          this.$refs.confirmDeleteConfirmModal.hide();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onDataErrorOccurred(e) {
      console.log("onDataErrorOccurred e", e);
      setTimeout(() => {
        let errorRow = document.querySelector(
          ".dx-treelist-headers .dx-error-message"
        );
        errorRow.innerHTML = this.$t("common.notes.anErrorOccurredGrid");
      }, 100);
    },
  },
};
</script>

<style lang="scss">
.sub-menu-text{
  font-size: 16px;
  color :#787878;
  line-height: 19px;
  padding: 0 10px;
  margin: 0;
}
.custom-white-bg-sec {
  background-color: #ffffff;
  padding-inline-start: 0px;
  padding-top: 0px !important;
  border-radius: 8px !important;

  button.unique-edit-button {
    outline: none;
    border: none;
    background: transparent;
    padding: 0px !important;
  }
  button.unique-edit-button:disabled {
    opacity: 1 !important;
    cursor: not-allowed;
  }
  button.unique-edit-button:focus {
    outline: none;
    border: none;
    background: transparent;
  }
  button.delete-button {
    outline: none;
    border: none;
    background: transparent;
    margin-inline-start: 16px;
    padding: 0px !important;
  }
  button.delete-button:focus {
    outline: none;
    border: none;
    background: transparent;
  }
  .dx-treelist-container.dx-gridbase-container {
    border-start-end-radius: 8px !important;
    border-start-start-radius: 8px !important;
  }
}
div#category-two.tooltip,
.tooltip-right {
  .tooltip-inner {
    background-color: red !important;
    padding: 12px;
    //min-width: 218px !important;
    transition: none !important;
    margin-inline-start: 5px;
    margin-top: -12px !important;
  }
}
div#category-two.tooltip.b-tooltip .arrow {
  display: none !important;
}
div#category.tooltip.b-tooltip .arrow {
  display: none !important;
}
div#category-two.tooltip {
  .tooltip-inner {
    background-color: #ffffff !important;

    max-width: 218px !important;
  }
}
div#customFieldsTreelist {
  div#customFieldsTreelist
    .dx-treelist-headers
    .dx-treelist-table
    .dx-row
    > td {
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 17px !important;

    color: #787878 !important;
  }
  td {
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 19px !important;

    color: #4a4a4a !important;
  }
  .dx-treelist-header-panel {
    padding-inline-start: 0 !important;
    padding-inline-end: 0 !important;
  }

  .dx-treelist-filter-row {
    background-color: #ffff;
    height: 42px !important;
    padding: 0px !important;
    margin: 0px !important;
  }
}

div#category.tooltip {
  .tooltip-inner {
    background-color: #ffffff !important;

    max-width: 218px !important;
  }
}
button.category-text {
  background-color: #ffffff;
  padding-top: 16px !important;
  padding-bottom: 12px;
  border: none;
  color: #787878;
  width: 127px;
  line-height: 19px;
  word-break: break-word !important;
  font-size: 16px;
  font-weight: 400;
  border-start-start-radius: 6px;
  border-start-end-radius: 6px;
}
button.category-text:focus {
  background: #e5f0fd !important;
  box-shadow: 0px 3px 3px 0px #00000029;
}

div#customFieldsTreelist {
  .download-pdf.dx-template-wrapper {
    color: #2680eb;
    font-size: 16px;
    font-weight: 700;

    line-height: 19px;
    cursor: pointer !important;
    span {
      cursor: pointer !important;
    }
  }
  .download-pdf.dx-template-wrapper span:read-only {
    cursor: pointer !important;
  }
  .dx-treelist-header-panel {
    padding-inline-start: 0 !important;
    padding-inline-end: 0 !important;
  }

  .dx-treelist-filter-row {
    background-color: #ffff;
    height: 42px !important;
    padding: 0px !important;
    margin: 0px !important;
  }
}

div#add-custom-grid {
  //height: 60vh;
  .dropdown-content-two {
    display: none;
    position: absolute;
    background-color: #ffffff;
    max-width: 127px;
    margin-top: -2px;
    display: block;
    margin-inline-start: 133px;
    border-radius: 4px !important;
    padding: 0px !important;
    z-index: 1;

    box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.1607843137) !important;
    ul {
      // width: 127px !important;
      margin-bottom: 0px !important;
      li.line-sep {
        margin-top: 12px;
        margin-bottom: 12px;
        height: 2px;
        background: #f2f2f2;
      }
      span.category-text {
        color: #787878;

        word-break: break-word !important;
        line-height: 19px;
        font-size: 16px;
        font-weight: 400;
      }
      span.compliance-text {
        color: #787878;

        word-break: break-word !important;
        line-height: 19px;
        font-size: 16px;
        font-weight: 400;
      }
      li.compliance-list {
        padding-bottom: 16px;
        text-align: center;
      }
      li.category-list {
        padding-top: 16px;
      }
    }
    svg:focus {
      outline: none !important;
    }
  }
  li.compliance-list-two {
    text-align: center;
  }
  .bs-tooltip-right .arrow::before {
    color: transparent !important;
    display: none !important;
    background-color: transparent !important;
    border-right-color: transparent !important;
  }
  svg:focus {
    outline: none !important;
    border: none !important;
  }

  div#categries.tooltip,
  .tooltip-right {
    .tooltip-inner {
      background-color: #ffffff !important;
      padding: 12px;
      max-width: 218px !important;
      transition: none !important;
      margin-inline-start: 10px;
      margin-top: 20px;
    }
  }

  .dropdown {
    position: relative;
    display: inline-block;
  }

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #ffffff;
    max-width: 127px;
    margin-top: 5px;
    margin-inline-start: 40px;
    border-radius: 6px !important;
    padding: 0px !important;
    z-index: 1;
    box-shadow: 0px 3px 3px 0px #00000029 !important;
    ul {
      margin-bottom: 0px !important;
      li.line-sep {
        margin-top: 12px;
        margin-bottom: 12px;
        height: 2px;
        background: #f2f2f2;
      }
      span.category-text {
        color: #787878;

        line-height: 19px;
        font-size: 16px;
        font-weight: 400;
      }
      span.compliance-text {
        color: #787878;

        line-height: 19px;
        font-size: 16px;
        font-weight: 400;
      }
      li.compliance-list {
        padding-bottom: 16px;
        text-align: center;
      }
      li.category-list {
        padding-top: 16px;
      }
    }
    svg:focus {
      outline: none !important;
    }
  }

  .dropdown .dropdown-content {
    display: block;
  }
  button.d-flex.align-items-center.justify-content-center.text-center.add-compliance-category {
    width: 127px;
    height: 27px;
    margin-inline-start: 40px;
    font-size: 16px;
    line-height: 19px;
    font-weight: 400;
    color: #ffffff;
    border: none;
    border-radius: 13.5px;
    background-color: #103f5e;
    &:disabled {
      opacity: 1 !important;
      background-color: #9fb2bf;
      cursor: not-allowed;
    }
  }

  ul {
    // width: 127px !important;
    margin-bottom: 0px !important;
    li.line-sep {
      margin-top: 12px;
      margin-bottom: 12px;
      height: 2px;
      background: #f2f2f2;
    }
    span.category-text {
      color: #787878;

      line-height: 19px;
      font-size: 16px;
      font-weight: 400;
      /* padding-top: 16px!important; */
    }
    span.compliance-text {
      color: #787878;

      line-height: 19px;
      font-size: 16px;
      font-weight: 400;
      /* padding-top: 16px!important; */
    }
    li.compliance-list {
      padding-bottom: 16px;
      text-align: center;
    }
    li.category-list {
      padding-top: 16px;
    }
  }
  svg:focus {
    outline: none !important;
  }
}
li.compliance-list-two {
  /* padding-bottom: 16px; */
  text-align: center;
}

.bs-tooltip-right .arrow::before {
  color: transparent !important;
  display: none !important;
  background-color: transparent !important;
  border-right-color: transparent !important;
}
svg:focus {
  outline: none !important;
  border: none !important;
}
div#category.tooltip,
.tooltip-right {
  .tooltip-inner {
    background-color: #ffffff !important;
    padding: 12px;
    //min-width: 218px !important;
    transition: none !important;
    margin-inline-start: 10px;
    margin-top: 10px;
  }
}
.add-tooltip {
  li.feature-availability,
  li.feature-upgrade {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: #787878;
  }
  .tooltip-container {
    position: relative;
    display: inline-block;
  }
  .tooltip-container:hover .tooltiptext {
    visibility: visible;
  }
  .tooltiptext {
    visibility: hidden;
    position: absolute;
    z-index: 1;
    width: 218px;
    background-color: #ffffff;
    color: #787878;
    box-shadow: 0px 3px 3px 0px #00000029;

    padding: 12px;
    border-radius: 6px;
    top: 130%;
    inset-inline-start: 1250%;
    transform: translateX(-50%);
  }
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #ffffff;
  max-width: 127px;
  margin-top: 5px;
  margin-inline-start: 40px;
  border-radius: 6px !important;
  padding: 0px !important;
  z-index: 1;
  box-shadow: 0px 3px 3px 0px #00000029 !important;
  ul {
    margin-bottom: 0px !important;
    li.line-sep {
      margin-top: 12px;
      margin-bottom: 12px;
      height: 2px;
      background: #f2f2f2;
    }
    span.category-text {
      color: #787878;

      line-height: 19px;
      font-size: 16px;
      font-weight: 400;
      /* padding-top: 16px!important; */
    }
    span.compliance-text {
      color: #787878;

      line-height: 19px;
      font-size: 16px;
      font-weight: 400;
      /* padding-top: 16px!important; */
    }
    li.compliance-list {
      padding-bottom: 16px;
      text-align: center;
    }
    li.category-list {
      padding-top: 16px;
    }
  }
  svg:focus {
    outline: none !important;
  }
}

.dropdown .dropdown-content {
  display: block;
}
div#add-custom-grid .dropdown-content ul span.compliance-text {
  color: #787878;
  line-height: 19px;
  font-size: 16px;
  display: flex;
  align-items: center;
  padding-inline-start: 10px !important;
  padding-inline-end: 10px !important;
  justify-content: center;
  justify-content: 400;
  /* padding-top: 16px !important; */
}
button.d-flex.align-items-center.justify-content-center.text-center.add-compliance-category {
  width: 127px;
  height: 27px;
  margin-inline-start: 40px;
  font-size: 16px;
  line-height: 19px;
  font-weight: 400;
  color: #ffffff;
  border: none;
  border-radius: 13.5px;
  background-color: #103f5e;
  &:disabled {
    opacity: 1 !important;
    background-color: #9fb2bf;
    cursor: not-allowed;
  }
}


.custom-field-grid:lang(ar) > .dx-rtl .dx-treeview-item-with-checkbox .dx-treeview-item {
  padding-right: 37px;
  padding-top: 8px;
}
.custom-field-grid:lang(ar) > .dx-dropdowneditor-overlay .dx-list-item-content, .dx-list-select-all-label, .dx-treeview-select-all-item, .dx-treeview-item-content{
  max-width: 115px;
}


</style>
